'use client';

import { useContext } from 'react';
import CountryFlag from 'components/gruenland/atoms/localization/CountryFlag';
import { MarketContext } from 'context/market';
import useCountry from 'helpers/hooks/useCountry';
import useLanguage from 'helpers/hooks/useLanguage';
import { LANGUAGE_NAMES } from 'project.config';

const MarketButtonContent = () => {
  const { market: selectedMarket } = useContext(MarketContext);
  const [language] = useLanguage();
  const [country] = useCountry();

  if (!selectedMarket) {
    return null;
  }

  return (
    <>
      {country.visible && <CountryFlag countryCode={selectedMarket.countryCode} />}
      <p>
        {selectedMarket?.region} / {LANGUAGE_NAMES[language.slice(0, 2)]}
      </p>
    </>
  );
};

export default MarketButtonContent;
